"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamBadgeDependencyMetric = exports.TeamBadgeMetric = exports.TeamBadge = void 0;
var TeamBadge;
(function (TeamBadge) {
    TeamBadge["NeedAttention"] = "NeedAttention";
    TeamBadge["OnTheRise"] = "OnTheRise";
    TeamBadge["TopPerformer"] = "TopPerformer";
})(TeamBadge = exports.TeamBadge || (exports.TeamBadge = {}));
var TeamBadgeMetric;
(function (TeamBadgeMetric) {
    TeamBadgeMetric["Velocity"] = "Velocity";
    TeamBadgeMetric["AvgPRSize"] = "Avg PR size";
    TeamBadgeMetric["AvgPRCycleTimeTotal"] = "Avg PR cycle time total";
    TeamBadgeMetric["AvgPRCycleTimeAwaitingReview"] = "Avg PR cycle time awaiting review";
    TeamBadgeMetric["PRReviewersPercent"] = "PR reviewers percent";
    TeamBadgeMetric["WorkDistributionBugsPercent"] = "Work distribution bugs percent";
    TeamBadgeMetric["MTTR"] = "MTTR";
})(TeamBadgeMetric = exports.TeamBadgeMetric || (exports.TeamBadgeMetric = {}));
// Note: when we will want to add metrics to the calculations (as additional metrics in the dev calculator)
// we will add it as a TeamBadgeDependencyMetric (for example, adding min of merged prs)
var TeamBadgeDependencyMetric;
(function (TeamBadgeDependencyMetric) {
})(TeamBadgeDependencyMetric = exports.TeamBadgeDependencyMetric || (exports.TeamBadgeDependencyMetric = {}));
//# sourceMappingURL=team-badges.js.map